<section class="w-full">
     <app-banner_section-type01 [options]="{title:view.title ,imageHref:view.imageHref}"></app-banner_section-type01>
    
    <app-scroller_section-type01></app-scroller_section-type01>
       <div class="w-full mx-auto sm:px-6 pt-8 pb-16 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8 lg:gap-y-16">
        <div>
                <div class="p-4 rounded-3xl">
                    <div class="flex flex-col">
                        @if (view.site && view.site.profile && view.site.profile.heading) {
                            @switch (view.site.profile.heading.banner) {
                                @case (1) {
                                <app-heading_section-type01
                                    [options]="{heading:view.page?.content.name,title:'Transform Your Corporate Travel Experience',image:'', description:'',swooshAlign: {'margin':''} }"></app-heading_section-type01>
                                }
                                @case (2) {
                                <app-heading_section-type01
                                    [options]="{heading:'',title:'Transform Your Corporate Travel Experience',image:'', description:''}"></app-heading_section-type01>
                                }
                            }
                        }
                    </div>
                </div>
                <div>
                    <!-- <p class="px-4 pb-10 text-justify" [innerHTML]="view.page?.content.rawContent"></p> -->
                    <p class="px-4 pb-10 text-justify">Our customizable corporate travel programs align seamlessly with your company's requirements, ensuring duty of care and effective risk management through automated travel advisories and alerts. We focus on delivering an exceptional client experience, guiding you from the initial requisition to post-travel support. Our fast-acting systems identify out-of-policy behavior swiftly, while our partnership with Egencia enhances global travel management. With industry-leading technology, we maximize returns by serving our customers' needs effectively. Monitoring travel performance is made easy with email alerts, scheduled reporting, and dynamic insights. Experience unmatched customer care from dedicated consultants who prioritize your travel success in a competitive marketplace. Enjoy exceptional savings on hotels, cars, and airfare.</p>
                </div>
            </div>
            
            <div  class=" w-[100%] ">
                <iframe width="100%" height="100%" 
                    src="https://www.youtube.com/embed/72Q9wIOWFrM" 
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    allowfullscreen>
                </iframe>
            </div>
        </div>
    <div class="flex lg:flex-row flex-col  md:flex-row justify-center m-auto p-4 md:p-8 lg:p-15">
        <div class="pb-4">
            <div class="items-center justify-center">
                <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:md:grid-cols-2 m-auto justify-between  gap-3 mt-4">
                    <fuse-card class=" flex flex-col p-4" *ngFor="let item of view.metaDataContent | keyvalue">
                        <div class="w-full sm:flex justify-between items-center mb-3">
                            <h2 class="text-xl leading-snug font-extrabold dark:text-white truncate mb-1 sm:mb-0">
                            {{item.key}}
                            </h2>
                        </div>
                        <div class="flex items-center justify-between whitespace-normal">
                            <div class="flex flex-row max-w-md">
                                <p class="mb-2 text-gray-500 dark:text-white">{{item.value}}</p>
                            </div>
                        </div>
                    </fuse-card>
                </div>
            </div>
        </div>
        <!--  -->
        <fuse-card
            class="w-full m-0 md:m-4 lg:m-4 flex flex-col justify-center items-center  bg-white bg-cover bg-no-repeat bg-center dark:bg-slate-800  ">
            <div class="w-full flex justify-center items-center">
                <div class="flex flex-col justify-center items-center mt-5 sm:pl-5 sm:pr-5 sm:items-center text">
                    @if (view.site && view.site.profile && view.site.profile.heading) {
                    @switch (view.site.profile.heading.position) {
                    @case (1) {
                    <app-heading_section-type01
                        [options]="{heading:'Our Services',title:'We Provide Top-Quality Solutions for You',image:'', description:'',headingStyle: {'text-align': 'center'},swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                    }
                    @case (2) {
                    <app-heading_section-type01
                        [options]="{heading:'Corporate Travel',title:'',image:'assets/xltravel/swoosh-01.svg', description:'',headingStyle: {'text-align': 'center'} ,swooshAlign: {'margin': 'auto'}}"></app-heading_section-type01>
                    }
                    }
                    }
                    <p class="text-md max-w-128 text-gray-600 p-2 leading-6" [innerHTML]="view.page?.content.rawContentShort"></p>
                </div>
            </div>
        </fuse-card>
    </div>
   
    <div class="p-4 md:p-8 lg:p-12 xl:p-16">
        <app-counters-type01></app-counters-type01>
    </div>
</section>